<template>
  <div class="collection-index">
      <div class="top">
          <img v-if="top_url" :src="top_url" width="100%" />
          <!-- <img  src="@/assets/images/collection/Med conference_white.png" />
          <img src="@/assets/images/collection/CEC logo_white.png" style="float:right;height:41px;margin-top:6px;" /> -->
      </div>
      <div class="KV">
          <img v-if="banner_url" :src="banner_url" />
      </div>
      <div class="buttons">
          <div class="one-button" @click="skip(1)">
            <img src="@/assets/images/collection/personal.png" />
            <p>个人信息维护</p>
          </div>
          <div class="one-button">
            <img src="@/assets/images/collection/report_subject.png" @click="skip(2)"/>
            <p>上报讲题
            </p>
            <div class="deadline" v-if="date">
                <img src="@/assets/images/collection/deadline.png" />
                <p><span>{{date.substring(0,4)}}</span>年<span>{{parseInt(date.substring(5,7))}}</span>月<span>{{parseInt(date.substring(8,10))}}</span>日 <span>{{time}}</span></p>
            </div>
          </div>
          <div class="one-button" @click="skip(3)">
            <img src="@/assets/images/collection/money_subject.png" />
            <p>演讲劳务确认</p>
          </div>
          <div class="one-button" @click="skip(4)">
            <img src="@/assets/images/collection/contact.png" />
            <p>会议官网<br>及联系人</p>
          </div>
          <!-- <div class="one-button" @click="skip(5)">
            <img src="@/assets/images/collection/receive_address.png" />
            <p>收件地址</p>
          </div> -->
      </div>
        <van-popup
		v-model="is_show_popup"
		closeable
		position="center"
        class="tips"
		>
            <img src="@/assets/images/collection/pop_up.png" />
            <p>
                尊敬的老师，您好！<br>
                <br>
                您作为本次CEC2023大会Faculty成员，我们诚邀您通过本系统进行讲题上报。鉴于大会学术内容全面性，会务组保留与您进一步协商讲题内容的可能性。<br>
                <br>
                收到自荐讲题邀请的Faculty无需提交摘要。如您的同事没有收到讲题自荐邀请，敬请关注“CEC官方”公众号，获取征文通道。<br>
                <br>
                任何其他平台的注册报名均非官方通道。<br>
                我们非常建议由您本人亲自进行填写。<br>
                <br>
                <span style="display:block;text-align:right;">感谢您的支持</span>
                <span style="display:block;text-align:right;">CEC血管论坛会务组</span>
            </p>
            <button @click="skip(2)">上报页面</button>
            <p class="con">
                <img src="@/assets/images/collection/contact_qrcode.jpeg" style="width: 38px;margin: 0 auto;display: block;"/>
                <span>长按识别二维码添加CEC官方客服</span>
            </p>
		</van-popup>
  </div>
</template>

<script>
import {PersoanalUserInfo} from '../../config/interface.js'
export default {
    data(){
        return{
            is_show_popup:false,
            id:this.$route.query.id,
            date:'',
            time:'',
            top_url:'',
            banner_url:''
        }
    },
    created(){
        this.getUserInfo();
        document.title="CEC官方";
        if(common.is_weixin()){
			common.wxShare('课题申报@中国血管论坛CEC2023','上报课题截止时间：2023年9月30日，欢迎您填写您的课题，谢谢您。','cdn.edstatic.com/203012120000/b20d0c68aad9dc88de3d7708dbf6c374/2022/07/9a6c31a0-d2f1-490c-8aa0-5942dc78e9dc.png');
		}

    },
    methods:{
        //得到用户信息
        getUserInfo(){
            const url=PersoanalUserInfo;
            let params={};
            const method='POST';
            fetch(url,params,method)
            .then((res)=>{
                if(res.code==0){
                    let data=res.data;
                    localStorage.setItem('userInfo',JSON.stringify(data));
                    this.$store.dispatch('storageUserInfo',data);	
                    this.userInfo=data;
                    if(this.userInfo&&this.userInfo.mobile_status==1){
                        this.getDeadline();
                        // let top=this.$refs.line.getBoundingClientRect().top;
                        // let bottom=this.$refs.line.getBoundingClientRect().bottom;
                    }
                    else{
                        common.toast('未绑定手机',1000,'fail',()=>{
                                this.$router.replace({
                                path:'/collection/login',
                                query:{url:window.location.href}
                        })
                        })	
                    }
                }
            })
        },
        getDeadline(){
            const url='webapi/meetings/'+this.id+'/collects';
            //post必填参数，title,content，可选参数code
            let params={};
            const method='GET';
            fetch(url,params,method)
            .then((res)=>{
                if(res.code==0){
                    let data=res.data;
                    this.top_url=data.top_img;
                    this.banner_url=data.banner;
                    if(res.data.end_at){
                        this.date=res.data.end_at.split(" ")[0];
                        let time=res.data.end_at.split(" ")[1];
                        time=time.split(":");
                        this.time=time[0]+":"+time[1];

                    }
                }
            })
        },
        skip(type){
            switch(type){
                case 1:
                    this.$router.push({
						path:'/collection/personal',
                        query:{
                            id:this.id
                        }
					});
                    break;
                case 2:
                    this.$router.push({
						path:'/collection/subject',
                        query:{
                            id:this.id
                        }
					});
                    break;
                case 3:
                    this.$router.push({
						path:'/collection/fee',
                        query:{
                            id:this.id
                        }
					});
                    break;
                case 4:
                    this.$router.push({
						path:'/collection/contact',
                        query:{
                            id:this.id
                        }
					});
                    break;
                case 5:
                    window.location.href="http://vascularnews.mikecrm.com/PX09RNg";
                    break;
            }
        }

    }

}
</script>

<style lang="scss">
.collection-index{
    background-image: url('../../assets/images/collection/background.png');
    background-size: contain;
    margin-bottom: 30px;
    .top{
        // height: 53px;
        // background-color: #B01C06;
        // padding: 0 15px;
        img{
            // height: 31px;
            // vertical-align: middle;
            // margin-top: 11px;
            width: 100%;
        }
    }
    .KV{
        margin: 15px;
        img{
            width: 100%;
            border-radius: 10px;
        }
    }
    .buttons{
        display: flex;
        margin: 15px;
        flex: 1;
        flex-wrap: wrap;
        justify-content: space-between;
        .one-button{
            width: 48%;
            text-align: center;
            position: relative;
            img{
                width: 100%;
            }
            p{
                position: absolute;
                top: 55%;
                left: 50%;
                transform: translate(-50%, 0);
                color: #B01C06;
                font-size: 20px;
            }
            .deadline{
                position: absolute;
                bottom:100%;
                img{
                    width: 90%;
                }
                p{
                    margin-top: -10px;
                    color: #A77C2E;
                    font-size: 10px;
                    white-space:nowrap;
                    span{
                        font-size: 14px;
                    }
                }

            }
        }
    }
    .tips{
        width: 80%;
        background: transparent;
        max-width: 338px;
        img{
            width: 100%;
        }
        .van-popup__close-icon--top-right {
            top: -0.1rem;
            right: 0.1rem;
        }
        p{
            position: absolute;
            margin: 30px 40px;
            top: 0;
        }
        @media (min-width: 500px) {
            p {
                font-size: 12px;//页面宽度大于640px时，字体变为16像素的1.2倍
            }
        }
        button{
            position: absolute;
            left: 0px;
            width: 68%;
            height: 46px;
            bottom: 70px;
            color: white;
            font-size: 16px;
            left: 50%;
            transform: translate(-50%,0);
            border-radius: 10px;
            border: 2px solid rgba(255,255,255,0.5);
            background: #b01c06;
            background-blend-mode: normal;
        }
        .con{
            margin: 0;
            left: 50%;
            color: white;
            text-align: center;
            bottom: 10px;
            top: auto;
            transform: translate(-50%,0);
            white-space: nowrap;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/contributions/index.vue